import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

// Guard for admin & super-admin roles
export const adminGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  // const router = inject(Router);

  if (!(await auth.ensureAuthenticated())) {
    return false;
  }

  if (auth.hasAnyGroup('ILASY_ADMIN', 'ILASY_SU_ADMIN')) {
    return true;
  }

  return false;
};

export const superAdminGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!(await auth.ensureAuthenticated())) {
    return false;
  }

  if (auth.hasAnyGroup('ILASY_SU_ADMIN')) {
    return true;
  }

  await router.navigateByUrl('/admin');
  return false;
};

// Guard for camper (user) role
export const userCamperGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const parsed = router.parseUrl(router.url);
  let userlink = parsed.queryParams?.['userlink'];

  if (typeof userlink === 'string' && userlink.trim().length > 0) {
    return true;
  }

  // Also accept path like `/c/<userlink>`
  const path = router.url || '';
  const match = path.match(/^\/c\/([^\/?#]+)/);
  if (match && match[1]) {
    userlink = match[1];
    return true;
  }

  return true;
};
